import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { Link } from 'react-router-dom';
import { ModelOfMileage } from 'src/database';
import LoadingScreen from '../../components/LoadingScreen';
import { useListMileagesController, } from '../../controllers/Mileages/ListMileagesController';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import classNames from 'classnames';

const MileagesList: React.FC = () => {
    const { getMileageListController, handleMileageListController } = useListMileagesController();

    if (getMileageListController.loading) {
        return <LoadingScreen />
    };

    const actionBodyTemplate = (Mileage: ModelOfMileage) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-text p-button-success p-mr-2" onClick={() => handleMileageListController.openEditDialog(Mileage)} />
                <Button icon="pi pi-trash" className="p-button-rounded p-button-text p-button-danger" onClick={() => handleMileageListController.openDeleteDialog(Mileage)} />
            </React.Fragment>
        );
    };

    const editMileageDialogFooter = (
        <React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={handleMileageListController.closeEditDialog} />
            <Button type="submit" label="Salvar" icon="pi pi-check" className="p-button-text" onClick={() => { getMileageListController.formik.handleSubmit() }} />
        </React.Fragment>
    );

    const deleteMileageDialogFooter = (
        <React.Fragment>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={handleMileageListController.closeDeleteDialog} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text"
                onClick={() => {
                    getMileageListController.selectedMileage && handleMileageListController.removeMileage(getMileageListController.selectedMileage)
                }}
            />
        </React.Fragment>
    );

    const leftMileageToolbar = () => {
        return (
            <Link to="/mileageForm">
                <Button label="Cadastrar tipo de quilometragem" icon="pi pi-plus" className="p-button-success p-mr-2" />
            </Link>
        );
    };

    return (
        <div>
            <Toast ref={getMileageListController.toast} />
            <div className="p-card p-p-4 datatable-container">
                <Toolbar className="p-mb-4" left={leftMileageToolbar}></Toolbar>

                <DataTable className="p-datatable-sm"
                    dataKey="ID" rowHover scrollHeight={'100%'} scrollable
                    value={getMileageListController.mileagesData}>
                    <Column field="DESCRICAO" header="Tipo de quilometragem"></Column>
                    <Column body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
                </DataTable>
            </div>

            <Dialog
                className="p-fluid"
                style={{ width: '450px' }}
                visible={getMileageListController.editDialog}
                onHide={handleMileageListController.closeEditDialog}
                onShow={() => getMileageListController.formik.setFieldValue('DESCRICAO', getMileageListController.selectedMileage?.DESCRICAO)}
                footer={editMileageDialogFooter}
                header={`Editar tipo de quilometragem ${getMileageListController.selectedMileage?.DESCRICAO}`}
                modal
            >
                <div className="p-field">
                    <label htmlFor="description">Nome</label>
                    <InputText id="name" type="text"
                        value={getMileageListController.formik.values.DESCRICAO}
                        onChange={getMileageListController.formik.handleChange('DESCRICAO')}
                        required
                    />
                    <div className={classNames("p-invalid popup-fade", {
                        'popup-form-active': getMileageListController.formik.touched.DESCRICAO && getMileageListController.formik.errors.DESCRICAO,
                        'popup-form-inactive': !(getMileageListController.formik.touched.DESCRICAO && getMileageListController.formik.errors.DESCRICAO),
                    })}
                    >{getMileageListController.formik.errors.DESCRICAO}</div>
                </div>
            </Dialog>

            <Dialog
                style={{ width: '450px' }}
                visible={getMileageListController.deleteDialog}
                onHide={handleMileageListController.closeDeleteDialog}
                footer={deleteMileageDialogFooter}
                header="Remover tipo de quilometragem"
                modal
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {getMileageListController.selectedMileage && <span>Você tem certeza que deseja deletar o tipo de quilometragem <b>{getMileageListController.selectedMileage.DESCRICAO}</b>?</span>}
                </div>
            </Dialog>
        </div>

    );
};

export default MileagesList;